import { render, staticRenderFns } from "./cake_brands.vue?vue&type=template&id=03e6ba2a&scoped=true"
import script from "./cake_brands.vue?vue&type=script&lang=js"
export * from "./cake_brands.vue?vue&type=script&lang=js"
import style0 from "./cake_brands.vue?vue&type=style&index=0&id=03e6ba2a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.34_babel-core@7.0.0-bridge.0_@babel+core@7.0.0_f2752dac7684e9922cbc3a420999c69f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e6ba2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03e6ba2a')) {
      api.createRecord('03e6ba2a', component.options)
    } else {
      api.reload('03e6ba2a', component.options)
    }
    module.hot.accept("./cake_brands.vue?vue&type=template&id=03e6ba2a&scoped=true", function () {
      api.rerender('03e6ba2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/custom-layout/components/centerModule/cake_brands.vue"
export default component.exports